/**
 * Clamps the value to the range:
 * if it is less than the min, returns the min
 * if it is greater than the max, returns the max
 *
 * @param min - The min value
 * @param max - The max value
 * @param value - The value to clamp
 * @returns - The clamped value
 */
export function clamp(min: number, max: number, value: number): number {
    return Math.min(max, Math.max(min, value));
}
